import { createJSONRequest } from './create-request.js'

/**
 * Open suggestions for one actor, one per property.
 *
 * Its own endpoint rather than `/api/suggestions`, which is restricted to owners and members
 * because it drives the internal curation screens. Here the audience is the actor itself: the
 * profile wizard shows what has been proposed in place of the stored values, so whoever claimed
 * the profile has to be able to read them.
 */
export const fetchActorSuggestions = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/suggestions`,
  method: 'GET',
})

/**
 * Record what the person did with the suggestions they were shown.
 *
 * Status only: the wizard has already written the profile with whatever was in the form, so
 * applying the suggestion again server-side would write the same value twice.
 *
 * @param decisions [{ id, status: 'accepted' | 'accepted_and_edited' | 'denied', accepted_value? }]
 */
export const resolveActorSuggestions = (actorId, decisions) => createJSONRequest({
  url: `/api/actors/${actorId}/suggestions/resolve`,
  method: 'POST',
  data: { decisions },
})
